import {
  AccountingFields,
  MandatoryFields,
} from 'wflow-main-app/src/app/core/api/model/field-validations';
import { TranslateService } from '@ngx-translate/core';
import { KindEnum } from 'wflow-variables';
import {
  AccountingFieldItem,
  ERPFieldTemplate,
  IntegrationField,
} from 'wflow-main-app/src/app/store/integrations/integration.model';
import { ACCOUNTING_VALIDATION_FIELD_CAPTIONS } from 'wflow-main-app/src/app/shared/__const/accounting-map.const';
import { getDisabledFieldsForErp } from 'wflow-main-app/src/app/shared/__const/erp-list.const';
import { isFieldEnabledForErpAndKind } from '../../../erp-settings.data';

export const mapToFieldTemplates = (
  translateService: TranslateService,
  fields: AccountingFields,
  erpCode: string = defaultErpId,
  kind: KindEnum,
  vatCountry: string = 'CZ',
  reset = false,
): ERPFieldTemplate[] => {
  return [
    ...prepareItems(ACCOUNTING_VALIDATION_FIELD_CAPTIONS, translateService),
  ].map((_item) => {
    const enabled =
      erpCode === defaultErpId ||
      (erpCode !== noneErpId &&
        erpItemEnabled(erpCode, _item.name, kind, vatCountry));
    const data = reset
      ? {
          mandatory: MandatoryFields.Inactive,
          ...(enabled && fields[_item.name]),
          headerVisible: enabled,
          linesVisible: enabled,
        }
      : {
          headerVisible: enabled,
          linesVisible: enabled,
          mandatory: MandatoryFields.Inactive,
          ...fields[_item.name],
        };
    return {
      ..._item,
      data,
    };
  });
};

export const erpItemEnabled = (
  erp: string,
  itemName: string,
  kind: KindEnum,
  vatCountry: string,
): boolean => {
  if (erp === defaultErpId) {
    return true;
  }
  return isFieldEnabledForErpAndKind(itemName, erp, kind, vatCountry);
};

export const defaultErpId = 'other';
export const noneErpId = 'none';

export const buildDefaultAccountingFields = (
  fieldNames: string[],
  erpCode: string,
  vatCountry: string,
  kind: KindEnum,
): AccountingFieldItem => {
  const disabledFields = getDisabledFieldsForErp(erpCode);
  return Object.fromEntries(
    fieldNames.map((fieldName) => {
      const enabled =
        erpCode === defaultErpId ||
        (erpCode !== noneErpId &&
          erpItemEnabled(erpCode, fieldName, kind, vatCountry));
      const disabled = disabledFields.get(fieldName);
      return [
        fieldName,
        {
          mandatory: null,
          headerVisible: disabled?.headerDisabled ? false : enabled,
          linesVisible: disabled?.linesDisabled ? false : enabled,
        },
      ];
    }),
  );
};

const prepareItems = (
  list: IntegrationField[],
  translateService: TranslateService,
) => {
  return list
    .map((item) => ({
      ...item,
      label: translateService.instant(item.label),
    }))
    .sort((a, b) => a['label'].localeCompare(b['label']));
};
